import { Button, Fade, Modal, Typography, useMediaQuery } from "@mui/material";
import CloseIcon from "../../../assets/icons-svg/close.svg";
import Loader from "../Loader";
interface ModalProps {
  open: boolean;
  handleClose: (result?: any, action?: any) => void;
  children: React.ReactNode;
  title: string;
  handleSave?: () => void;
  showFooterLoader?: boolean;
}
export default function UiModal(props: ModalProps) {
  const { open, handleClose, children, title, handleSave, showFooterLoader } = props;
  const smDevice = useMediaQuery("(max-width:600px)");

  const modalHeaderDesktop = () => {
    return (
      <div className="edit-modal__header">
        <Typography variant="h6" component="h2">
          {title}
        </Typography>
        <button className="btn-close" onClick={handleClose}>
          <img src={CloseIcon} alt="Close" />
        </button>
      </div>
    );
  };
  const modalHeaderMobile = () => {
    return (
      <div className="edit-modal__header">
        <button className="btn-close" onClick={handleClose}>
          <img src={CloseIcon} alt="Close" />
        </button>
        <Typography variant="h6" component="h2">
          {title}
        </Typography>
        <Button variant="contained" className="btn-tertiary">
          Save
        </Button>
      </div>
    );
  };
  const modalFooter = () => {
    return (
      <div className="edit-modal__footer">
      
        {showFooterLoader ?  (
          <Loader footerLoader={true} />
        ):
        (
          <>
            {" "}
            <Button
              variant="contained"
              className="btn-secondary edit-modal__footer--cancel"
              onClick={handleClose}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className="btn-tertiary"
              type="submit"
              onClick={() => handleSave?.()}
            >
              Save Changes
            </Button>
          </>
        )}
      </div>
    );
  };
  const showModalHeader = () => {
    if (!smDevice) {
      return modalHeaderDesktop();
    }
    return modalHeaderMobile();
  };
  return (
    <Modal open={open} onClose={handleClose}>
      <Fade in={open}>
        <div className="edit-modal">
          {showModalHeader()}
          <div className="edit-modal__content">{children}</div>
          {!smDevice && modalFooter()}
        </div>
      </Fade>
    </Modal>
  );
}
